/* menu-components-2 1.0.0 */
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var howler = createCommonjsModule(function (module, exports) {
/*!
 *  howler.js v2.0.8
 *  howlerjs.com
 *
 *  (c) 2013-2018, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto iOS enabler.
      self.mobileAutoEnable = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'running' : 'running';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Mobile browsers will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _enableMobileAudio: function() {
      var self = this || Howler;

      // Only run this on mobile devices if audio isn't already eanbled.
      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
        return;
      }

      self._mobileEnabled = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function() {
        // Fix Android can not play in suspend state.
        Howler._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._mobileEnabled = true;
          self.mobileAutoEnable = false;

          // Remove the touch start listener.
          document.removeEventListener('touchstart', unlock, true);
          document.removeEventListener('touchend', unlock, true);
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchstart', unlock, true);
      document.addEventListener('touchend', unlock, true);

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';
        self.ctx.suspend().then(function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        });
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended') {
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;
      self._xhrWithCredentials = o.xhrWithCredentials || false;

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];
      self._playLock = false;

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onplayerror = o.onplayerror ? [{fn: o.onplayerror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio on iOS.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
        Howler._enableMobileAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload) {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        var num = 0;
        for (var i=0; i<self._sounds.length; i++) {
          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
            num++;
            id = self._sounds[i]._id;
          }
        }

        if (num === 1) {
          sprite = null;
        } else {
          id = null;
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Makr this sounded as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(soundId);
          }
        });

        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          setTimeout(function() {
            self._emit('play', sound._id);
          }, 0);
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);

      // Update the parameters of the sound
      sound._paused = false;
      sound._ended = false;
      sound._sprite = sprite;
      sound._seek = seek;
      sound._start = self._sprite[sprite][0] / 1000;
      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._loop = !!(sound._loop || self._sprite[sprite][2]);

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
            }, 0);
          }
        };

        if (Howler.state === 'running') {
          playWebAudio();
        } else {
          self.once('resume', playWebAudio);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          // Mobile browsers will throw an error if this is called without user interaction.
          try {
            var play = node.play();

            // Support older browsers that don't support promises, and thus don't have this issue.
            if (typeof Promise !== 'undefined' && play instanceof Promise) {
              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
              self._playLock = true;

              // Releases the lock and executes queued actions.
              play.then(function () {
                self._playLock = false;
                self._loadQueue();
              });
            }

            // If the node is still paused, then we can assume there was a playback issue.
            if (node.paused) {
              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                'on mobile devices where playback was not within a user interaction.');
              return;
            }

            // Setup the new end timer.
            if (timeout !== Infinity) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            if (!internal) {
              self._emit('play', sound._id);
            }
          } catch (err) {
            self._emit('playerror', sound._id, err);
          }
        };

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);
        if (node.readyState === 4 || loadedNoReadyState) {
          playHtml5();
        } else {
          var listener = function() {
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();
            }
          }

          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          // Cancel active fade and set the volume to the end value.
          if (sound._interval) {
            self._stopFade(sound._id);
          }

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
        }
      }

      return self;
    },

    /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */
    _startFadeInterval: function(sound, from, to, len, id, isGroup) {
      var self = this;
      var vol = from;
      var diff = to - from;
      var steps = Math.abs(diff / 0.01);
      var stepLen = Math.max(4, (steps > 0) ? len / steps : len);
      var lastTick = Date.now();

      // Store the value being faded to.
      sound._fadeTo = to;

      // Update the volume value on each interval tick.
      sound._interval = setInterval(function() {
        // Update the volume based on the time since the last tick.
        var tick = (Date.now() - lastTick) / len;
        lastTick = Date.now();
        vol += diff * tick;

        // Make sure the volume is in the right bounds.
        vol = Math.max(0, vol);
        vol = Math.min(1, vol);

        // Round to within 2 decimal points.
        vol = Math.round(vol * 100) / 100;

        // Change the volume.
        if (self._webAudio) {
          sound._volume = vol;
        } else {
          self.volume(vol, sound._id, true);
        }

        // Set the group's volume.
        if (isGroup) {
          self._volume = vol;
        }

        // When the fade is complete, stop it and fire event.
        if ((to < from && vol <= to) || (to > from && vol >= to)) {
          clearInterval(sound._interval);
          sound._interval = null;
          sound._fadeTo = null;
          self.volume(to, sound._id);
          self._emit('fade', sound._id);
        }
      }, stepLen);
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self.volume(sound._fadeTo, id);
        sound._fadeTo = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            sound._rateSeek = self.seek(id[i]);
            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else if (self._sounds.length) {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return self;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Restart the playback if the sound was playing.
          if (playing) {
            self.play(id, true);
          }

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node) {
            sound._node.currentTime = seek;
          }

          self._emit('seek', id);
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
          if (!checkIE) {
            sounds[i]._node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
          }

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);

        // Remove the references in the global Howler object.
        var index = Howler._howls.indexOf(self);
        if (index >= 0) {
          Howler._howls.splice(index, 1);
        }
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }

      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          var isId = (id === events[i].id);
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function() {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // don't move onto the next task until this one is done
        self.once(task.event, function() {
          self._queue.shift();
          self._loadQueue();
        });

        task.action();
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        clearTimeout(self._endTimers[id]);
        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop;
      }
      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;

      if (Howler._scratchBuffer) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        try { node.bufferSource.buffer = Howler._scratchBuffer; } catch(e) {}
      }
      node.bufferSource = null;

      return self;
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else {
        self._node = new Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = 'auto';
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.withCredentials = self._xhrWithCredentials;
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Decode the buffer into an audio source.
    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      }
    }, function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    });
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : 1, Howler.ctx.currentTime);
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (typeof undefined === 'function' && undefined.amd) {
    undefined([], function() {
      return {
        Howler: Howler,
        Howl: Howl
      };
    });
  }

  // Add support for CommonJS libraries such as browserify.
  {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Define globally in case AMD is not available or unused.
  if (typeof window !== 'undefined') {
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  } else if (typeof commonjsGlobal !== 'undefined') { // Add to global in Node.js (for testing, etc).
    commonjsGlobal.HowlerGlobal = HowlerGlobal;
    commonjsGlobal.Howler = Howler;
    commonjsGlobal.Howl = Howl;
    commonjsGlobal.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.0.8
 *  howlerjs.com
 *
 *  (c) 2013-2018, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
  
  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];
      self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];
      self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              sound._panner.setPosition(pan, 0, 0);
            } else {
              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            sound._panner.setPosition(x, y, z);
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            sound._panner.setOrientation(x, y, z);
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   * 
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          if (!o.pannerAttr) {
            o.pannerAttr = {
              coneInnerAngle: o.coneInnerAngle,
              coneOuterAngle: o.coneOuterAngle,
              coneOuterGain: o.coneOuterGain,
              distanceModel: o.distanceModel,
              maxDistance: o.maxDistance,
              refDistance: o.refDistance,
              rolloffFactor: o.rolloffFactor,
              panningModel: o.panningModel
            };
          }

          self._pannerAttr = {
            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
          panner.panningModel = pa.panningModel;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.panningModel = sound._pannerAttr.panningModel;
      sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id, true);
    }
  };
})();
});

var howler_1 = howler.Howler;
var howler_2 = howler.Howl;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var utilities$$1 = function () {
    function utilities$$1() {
        classCallCheck(this, utilities$$1);
    }

    createClass(utilities$$1, null, [{
        key: 'createPodiumGroups',
        value: function createPodiumGroups(Podiumdata, ImageHandler, SoundHandler, TextHandler, TextFileHandler, GroupHandler) {
            var podiumdata = new Podiumdata(liquidData.BaseUri);
            podiumdata.feed(JSON.parse(liquidData.PodiumDataJson));
            podiumdata.setImageHandler(ImageHandler);
            podiumdata.setSoundHandler(SoundHandler);
            podiumdata.setTextHandler(TextHandler);
            podiumdata.setTextFileHandler(TextFileHandler);
            podiumdata.setGroupHandler(GroupHandler);

            globals.pg = podiumdata.group;
            globals.pgPrivate = globals.pg.getGroup('private');
            globals.pgPrivateAssets = globals.pgPrivate.getGroup('assets');
            globals.pgBilingual = globals.pg.getGroup('bilingualLanguage');
        }
    }, {
        key: 'initClickBorderRemoval',
        value: function initClickBorderRemoval() {
            function handleFirstTab(e) {
                if (e.keyCode === 9) {
                    document.body.classList.add('user-is-tabbing');

                    window.removeEventListener('keydown', handleFirstTab);
                    window.addEventListener('mousedown', handleMouseDownOnce);
                }
            }

            function handleMouseDownOnce() {
                document.body.classList.remove('user-is-tabbing');

                window.removeEventListener('mousedown', handleMouseDownOnce);
                window.addEventListener('keydown', handleFirstTab);
            }
            window.addEventListener('keydown', handleFirstTab);
        }
    }, {
        key: 'activatePageLinks',
        value: function activatePageLinks() {
            Array.from(document.getElementsByTagName('a')).concat(Array.from(document.getElementsByTagName('button'))).forEach(function (element) {
                if (typeof element.href !== 'undefined') {
                    if (element.href.length > 0) {
                        element.tabIndex = 0;
                    }
                } else {
                    element.tabIndex = 0;
                }
            });

            var subNavigationContainer = document.getElementById('salaby-burger-navigation-container');
            if (subNavigationContainer.clientHeight <= 0) {
                Array.from(subNavigationContainer.getElementsByTagName('a')).concat(Array.from(subNavigationContainer.getElementsByTagName('button'))).forEach(function (element) {
                    element.tabIndex = -1;
                });
            }
        }
    }, {
        key: 'deactivatePageLinks',
        value: function deactivatePageLinks() {
            Array.from(document.getElementsByTagName('a')).concat(Array.from(document.getElementsByTagName('button'))).forEach(function (element) {
                element.tabIndex = -1;
            });
        }
    }, {
        key: 'createSidePanel',
        value: function createSidePanel() {
            var _this = this;

            var sidePanelWrapper = this.createElement(document.body, 'div', 'side-panel-wrapper');

            var sidePanelHeader = this.createElement(sidePanelWrapper, 'div', 'side-panel-header');

            var sidePanelCloseButton = this.createElement(sidePanelHeader, 'button', 'close-side-panel-button', null, globals.pgPrivateAssets.getText('button_close_side_panel').asString(), globals.pgPrivateAssets.getText('button_close_side_panel').getImage().getUrl());
            sidePanelCloseButton.addEventListener('click', function () {
                var panel = document.getElementById('side-panel-wrapper');
                var languagePanelWidth = panel.clientWidth;
                _this.deactivatePageLinks();
                TweenMax.to(panel, 0.2, {
                    css: { right: -languagePanelWidth }, onComplete: function onComplete() {
                        document.body.removeChild(panel);
                        _this.activatePageLinks();
                    }
                });
            });

            this.createElement(sidePanelWrapper, 'div', 'side-panel-container');

            var languagePanelWidth = sidePanelWrapper.clientWidth;
            TweenMax.set(sidePanelWrapper, { css: { right: -languagePanelWidth } });
            TweenMax.to(sidePanelWrapper, 0.4, { css: { right: 0 } });
        }
    }, {
        key: '_createElement',
        value: function _createElement(parent) {
            var elementType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
            var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var innerHTLM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            var element = document.createElement(elementType);

            if (id !== null) {
                element.id = id;
            }

            if (className !== null) {
                element.className = className;
            }

            if (parent !== null) {
                parent.appendChild(element);
            }

            if (innerHTLM !== null) {
                element.innerHTML = innerHTLM;
            }

            return element;
        }
    }, {
        key: 'addBackgroundCssImage',
        value: function addBackgroundCssImage(element) {
            var podiumAssetGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var podiumKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            if (podiumAssetGroup !== null && podiumKey !== null) {
                element.style.backgroundImage = 'url("' + podiumAssetGroup.getImage(podiumKey).getUrl() + '")';
            } else if (url !== null) {
                element.style.backgroundImage = 'url("' + url + '")';
            }
        }
    }, {
        key: 'createImageElement',
        value: function createImageElement(url) {
            var competeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var image = new Image();
            if (competeCallback !== null) {
                image.addEventListener('load', function (event) {
                    competeCallback(event);
                });
            }
            image.src = url;
            return image;
        }
    }, {
        key: 'createElement',
        value: function createElement(parent) {
            var elementType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
            var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var innerHTLM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var backgroundImage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

            var element = document.createElement(elementType);

            if (id !== null) {
                element.id = id;
            }

            if (className !== null) {
                element.className = className;
            }

            if (parent !== null) {
                parent.appendChild(element);
            }

            if (innerHTLM !== null) {
                element.innerHTML = innerHTLM;
            }

            if (backgroundImage) {
                element.style.backgroundImage = 'url(\'' + backgroundImage + '\')';
            }

            return element;
        }
    }, {
        key: 'createImageButton',
        value: function createImageButton(parent, podiumAssetGroup, podiumKey) {
            var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var tabIndex = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
            var elementType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'button';
            var src = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
            var href = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;

            var button = this.createButton(parent, id, className, callback, tabIndex, elementType, src, href);
            this.addBackgroundCssImage(button, podiumAssetGroup, podiumKey);
            return button;
        }
    }, {
        key: 'createTextButton',
        value: function createTextButton(parent, text) {
            var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var tabIndex = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
            var elementType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'button';
            var href = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

            var button = this.createButton(parent, id, className, callback, tabIndex, elementType, null, href);
            button.appendChild(document.createTextNode(text));
            return button;
        }
    }, {
        key: 'createButton',
        value: function createButton(parent) {
            var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var tabIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
            var elementType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'button';
            var src = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            var href = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

            var button = document.createElement(elementType);
            if (id !== null) {
                button.id = id;
            }

            if (className !== null) {
                button.className = className;
            }

            button.tabIndex = tabIndex;
            parent.appendChild(button);

            button.addEventListener('mousedown', function (event) {
                event.currentTarget.blur();
                event.currentTarget.setAttribute('data-mousedown', 'true');
            });

            button.addEventListener('focus', function (event) {
                var attr = event.currentTarget.getAttribute('data-mousedown');
                if (attr !== null) {
                    if (attr === 'true') {
                        event.currentTarget.blur();
                        event.currentTarget.removeAttribute('data-mousedown');
                    }
                }
            });

            if (callback !== null) {
                button.addEventListener('click', function (event) {
                    callback(event);
                });
            }

            if (src !== null) {
                button.setAttribute('src', src);
            }

            if (href !== null) {
                button.setAttribute('href', href);
            }

            return button;
        }
    }, {
        key: '_addClassName',
        value: function _addClassName(element, className) {
            var currentClassName = element.className;
            if (currentClassName.includes(className)) {
                return;
            }
            element.className += ' ' + className;
        }
    }, {
        key: '_removeClassName',
        value: function _removeClassName(element, className) {
            var currentClassName = element.className;
            if (currentClassName.includes(className)) {
                var newClassName = element.className.replace(className, '');
                element.className = newClassName;
            }
        }
    }]);
    return utilities$$1;
}();

var Bilingual$$1 = function () {
    function Bilingual$$1() {
        classCallCheck(this, Bilingual$$1);

        // This._languagePanelWrapper = null;
        this._languagePanelWidthPercent = 0.3;

        this._predefinedJSONList = null;
        this._bilingualJSONList = null;
        this._jsonSearchList = [];
        this._canSearch = globals.pgBilingual.getParameter('searchEnable').asBool();

        this._predefinedList = globals.pgBilingual.getParameterOptional('predefinedList', null);

        if (liquidData.BilingualLanguage) {
            if (liquidData.BilingualLanguage.CultureCode === 'ku-ku' || liquidData.BilingualLanguage.CultureCode === 'ar-iq' || liquidData.BilingualLanguage.CultureCode === 'ur-pk' || liquidData.BilingualLanguage.CultureCode === 'prs-af' || liquidData.BilingualLanguage.CultureCode === 'fa-ir') {
                this._bilingualLanguageDirection = 'rtl';
            } else {
                this._bilingualLanguageDirection = 'ltr';
            }
        } else {
            this._bilingualLanguageDirection = 'ltr';
        }

        if (liquidData.BilingualLanguage) {
            this._loadeBilingualJsonList();
        }
    }

    createClass(Bilingual$$1, [{
        key: '_loadeBilingualJsonList',
        value: function _loadeBilingualJsonList() {
            var _this = this;

            if (this._bilingualJSONList === null) {
                var bilingualJSONURL = globals.pgPrivate.getParameter('url_bilingual_dictionary').asString() + liquidData.Language.CultureCode + '/' + liquidData.BilingualLanguage.CultureCode;
                var xhr = new XMLHttpRequest();
                xhr.open('GET', bilingualJSONURL);
                xhr.withCredentials = false;
                xhr.onload = function () {
                    _this._bilingualJSONList = JSON.parse(xhr.responseText).list;
                };
                xhr.send();
            }
        }

        // ---------- Function opening the select language panel. ----------//

    }, {
        key: 'selectLanguageButtonClick',
        value: function selectLanguageButtonClick() {
            utilities$$1.createSidePanel();

            var sidePanelHeader = document.getElementById('side-panel-header');
            utilities$$1.createElement(sidePanelHeader, 'h2', null, null, globals.pgPrivate.getText('text_bilingual_select_header').asString());

            var sidePanelContainer = document.getElementById('side-panel-container');
            var sidePanelContentContainer = utilities$$1.createElement(sidePanelContainer, 'ul');

            if (liquidData.BilingualLanguages.length > 0) {
                var noLanguageButtonContainer = utilities$$1._createElement(sidePanelContentContainer, 'li');
                var noLanguageButton = utilities$$1._createElement(noLanguageButtonContainer, 'a', null, null, 'Ingen');
                noLanguageButton.href = liquidData.ClearBilingualLanguageUrl;

                if (liquidData.BilingualLanguage === null) {
                    noLanguageButton.className = 'selected';
                }

                liquidData.BilingualLanguages.forEach(function (bilingualLanguage) {
                    var listName = bilingualLanguage.EnglishName;
                    if (bilingualLanguage.CultureCode === 'tr-tr') {
                        listName = 'Türkçe/Tyrkisk';
                    } else if (bilingualLanguage.CultureCode === 'pl-pl') {
                        listName = 'Polski/Polsk';
                    } else if (bilingualLanguage.CultureCode === 'so-so') {
                        listName = 'Soomaali/Somali';
                    } else if (bilingualLanguage.CultureCode === 'ta-lk') {
                        listName = 'தமிழ்/Tamil';
                    } else if (bilingualLanguage.CultureCode === 'ti-er') {
                        listName = 'Tigriñña/Tigrinja';
                    } else if (bilingualLanguage.CultureCode === 'ar-iq') {
                        listName = 'العربية/Arabisk';
                    } else if (bilingualLanguage.CultureCode === 'ur-pk') {
                        listName = 'اردو/Urdu';
                    } else if (bilingualLanguage.CultureCode === 'ku-ku') {
                        listName = 'سۆرانی/Sorani';
                    } else if (bilingualLanguage.CultureCode === 'vi-vn') {
                        listName = 'Tiếng Việt/Vietnamesisk';
                    } else if (bilingualLanguage.CultureCode === 'tl-ph') {
                        listName = 'Tagalog/Tagalog';
                    } else if (bilingualLanguage.CultureCode === 'am-et') {
                        listName = 'አማርኛ Amarəñña/Amharisk';
                    } else if (bilingualLanguage.CultureCode === 'prs-af') {
                        listName = 'درى (افغانستان)/Dari';
                    } else if (bilingualLanguage.CultureCode === 'kmr-tr') {
                        listName = 'Kurmanji (Turkey)/Kurmanji';
                    } else if (bilingualLanguage.CultureCode === 'om-et') {
                        listName = 'Oromo (Ethiopia)/Oromo';
                    } else if (bilingualLanguage.CultureCode === 'fa-ir') {
                        listName = 'فارسى (ایران)/Farsi';
                    }
                    var languageButtonContainer = utilities$$1._createElement(sidePanelContentContainer, 'li');
                    var languageButton = utilities$$1._createElement(languageButtonContainer, 'a', null, null, listName);
                    languageButton.href = bilingualLanguage.SetLanguageUrl;

                    if (liquidData.BilingualLanguage !== null) {
                        if (bilingualLanguage.CultureCode === liquidData.BilingualLanguage.CultureCode) {
                            languageButton.className = 'selected';
                        }
                    }
                });
            }
        }

        // ---------- close select language panel click handler. ----------//

    }, {
        key: '_selectLanguagePanelCloseButtonButtonClick',
        value: function _selectLanguagePanelCloseButtonButtonClick() {
            utilities$$1.activatePageLinks();

            var bilingualSelectLanguageButton = document.getElementById('bilingual-select-language-button');
            if (bilingualSelectLanguageButton) {
                document.getElementById('bilingual-select-language-button').focus();
                document.getElementById('bilingual-select-language-button').blur();
            } else {
                document.getElementById('bilingual-select-language-text-button').focus();
                document.getElementById('bilingual-select-language-text-button').blur();
            }

            if (this._closeSelectLanguageHandler) {
                this._closeSelectLanguageHandler();
            }

            document.body.style.overflowY = '';
            document.body.removeChild(document.getElementById('bilingual-select-language-wrapper'));
        }
    }, {
        key: 'openLanguagePanel',
        value: function openLanguagePanel() {
            this._createLanguagePanel();
        }
    }, {
        key: '_createLanguagePanel',
        value: function _createLanguagePanel() {
            var _this2 = this;

            utilities$$1.createSidePanel();
            var sidePanelHeader = document.getElementById('side-panel-header');

            console.log(globals.pgPrivate.getText('text_bilingual_header').asString());

            var header = utilities$$1.createElement(sidePanelHeader, 'h2', null, null, globals.pgPrivate.getText('text_bilingual_header').asString() + ' ');
            var spane = utilities$$1.createElement(header, 'span', null, null, liquidData.BilingualLanguage.EnglishName);
            spane.style.fontWeight = '700';

            var sidePanelContainer = document.getElementById('side-panel-container');
            sidePanelContainer.style.backgroundColor = 'transparent';

            // ---------- Create text input area ----------//
            var sidePanelInputsContainer = utilities$$1.createElement(sidePanelContainer, 'div', 'side-panel-inputs-container');

            // ---------- Input1 ----------//
            var textsInputWrapper1 = document.createElement('div');
            textsInputWrapper1.className = 'bl-lp-input-wrapper';
            sidePanelInputsContainer.appendChild(textsInputWrapper1);

            var textsInputContainer1 = document.createElement('div');
            textsInputContainer1.id = 'bl-lp-input-container1';
            textsInputContainer1.className = 'bl-lp-input-container';
            textsInputWrapper1.appendChild(textsInputContainer1);

            var textsInput1 = document.createElement('input');
            textsInput1.id = 'bl-lp-input1';
            textsInput1.className = 'bl-lp-input';
            textsInput1.setAttribute('type', 'text');
            textsInput1.setAttribute('placeholder', liquidData.Language.NativeName);
            textsInputContainer1.appendChild(textsInput1);

            var deleteTextBtn1 = utilities$$1.createElement(textsInputContainer1, 'button', null, 'bl-lp-input-x', null, globals.pgPrivateAssets.getImage('bilingualButtonDeleteText').getUrl());
            deleteTextBtn1.addEventListener('click', function () {
                return _this2._resetTextInputs();
            });

            textsInput1.addEventListener('keyup', function () {
                var textInput = document.getElementById('bl-lp-input1');
                var searchListContainer = document.getElementById('bl-lp-search-list-container');
                var predefinedListContainer = document.getElementById('bl-lp-predefined-list-container');
                var searchField = textInput.value;
                var pattern = '^' + searchField;
                _this2._regex = new RegExp(pattern, 'i');

                if (textInput.value.length > 0) {
                    predefinedListContainer.style.display = 'none';
                    searchListContainer.style.display = 'block';
                } else {
                    predefinedListContainer.style.display = 'block';
                    searchListContainer.style.display = 'none';
                }

                if (textInput.value.length >= 1) {
                    _this2._jsonSearchList = [];

                    if (textInput.value.length > 0) {
                        _this2._bilingualJSONList.forEach(function (listItem) {
                            if (listItem.lang1_text.search(_this2._regex) !== -1) {
                                _this2._jsonSearchList.push(listItem);
                            }
                        });
                    }

                    searchListContainer.innerHTML = '';

                    _this2._jsonSearchList.forEach(function (listItem) {
                        _this2._createListItemDom(listItem, searchListContainer);
                    });
                }
            });

            // ---------- Input2 ----------//
            var textsInputWrapper2 = document.createElement('div');
            textsInputWrapper2.className = 'bl-lp-input-wrapper';
            sidePanelInputsContainer.appendChild(textsInputWrapper2);

            var textsInputContainer2 = document.createElement('div');
            textsInputContainer2.id = 'bl-lp-input-container2';
            textsInputContainer2.className = 'bl-lp-input-container';
            textsInputWrapper2.appendChild(textsInputContainer2);

            var textsInput2 = document.createElement('input');
            textsInput2.id = 'bl-lp-input2';
            textsInput2.className = 'bl-lp-input';
            textsInput2.setAttribute('type', 'text');
            textsInput2.setAttribute('placeholder', liquidData.BilingualLanguage.NativeName);
            textsInput2.setAttribute('dir', this._bilingualLanguageDirection);

            textsInputContainer2.appendChild(textsInput2);

            // TODO: add button text.
            var deleteTextBtn2 = utilities$$1.createElement(textsInputContainer2, 'button', null, 'bl-lp-input-x', null, globals.pgPrivateAssets.getImage('bilingualButtonDeleteText').getUrl());
            deleteTextBtn2.addEventListener('click', function () {
                return _this2._resetTextInputs();
            });

            textsInput2.addEventListener('keyup', function () {
                var textInput = document.getElementById('bl-lp-input2');
                var searchListContainer = document.getElementById('bl-lp-search-list-container');
                var predefinedListContainer = document.getElementById('bl-lp-predefined-list-container');
                var searchField = textInput.value;
                var pattern = '^' + searchField;
                _this2._regex = new RegExp(pattern, 'i');

                if (textInput.value.length <= 0) {
                    return;
                }

                if (textInput.value.length > 0) {
                    predefinedListContainer.style.display = 'none';
                    searchListContainer.style.display = 'block';
                } else {
                    predefinedListContainer.style.display = 'block';
                    searchListContainer.style.display = 'none';
                }

                if (textInput.value.length >= 1) {
                    _this2._jsonSearchList = [];

                    if (textInput.value.length > 0) {
                        _this2._bilingualJSONList.forEach(function (listItem) {
                            if (listItem.lang2_text.search(_this2._regex) !== -1) {
                                _this2._jsonSearchList.push(listItem);
                            }
                        });
                    }

                    searchListContainer.innerHTML = '';

                    _this2._jsonSearchList.forEach(function (listItem) {
                        _this2._createListItemDom(listItem, searchListContainer);
                    });
                }
            });

            // ---------- Create Lists ----------//
            var listContainer = document.createElement('div');
            listContainer.id = 'bl-lp-list-container';
            sidePanelContainer.appendChild(listContainer);

            var predefinedListContainer = document.createElement('ul');
            predefinedListContainer.id = 'bl-lp-predefined-list-container';
            predefinedListContainer.className = 'bl-lp-list';
            listContainer.appendChild(predefinedListContainer);

            var searchListContainer = document.createElement('ul');
            searchListContainer.id = 'bl-lp-search-list-container';
            searchListContainer.className = 'bl-lp-list';
            listContainer.appendChild(searchListContainer);

            this._createPredefinedListItems();
        }

        // ---------- Functions for language search panel ----------//

    }, {
        key: '_createPredefinedListItems',
        value: function _createPredefinedListItems() {
            var _this3 = this;

            if (this._predefinedList) {
                if (this._predefinedJSONList === null) {
                    var bilingualJSONURL = globals.pgPrivate.getParameter('url_bilingual_dictionary').asString() + liquidData.Language.CultureCode + '/' + liquidData.BilingualLanguage.CultureCode + '?pick=' + this._predefinedList.asString();
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', bilingualJSONURL);
                    xhr.withCredentials = false;
                    xhr.onload = function () {
                        _this3._predefinedJSONList = JSON.parse(xhr.responseText).list;

                        _this3._predefinedJSONList.forEach(function (listItem) {
                            _this3._createListItemDom(listItem, document.getElementById('bl-lp-predefined-list-container'));
                        });
                    };
                    xhr.send();
                } else {
                    this._predefinedJSONList.forEach(function (listItem) {
                        _this3._createListItemDom(listItem, document.getElementById('bl-lp-predefined-list-container'));
                    });
                }
            }
        }
    }, {
        key: '_createListItemDom',
        value: function _createListItemDom(jsonObject, listItemContainer) {
            var _this4 = this;

            var itemContainer = document.createElement('li');
            itemContainer.className = 'bl-lp-list-item';
            listItemContainer.appendChild(itemContainer);

            var textContainer = utilities$$1.createElement(itemContainer, 'div', null, 'bl-list-text-container');

            // Check if image exist in language item.
            if (jsonObject.image.length > 0) {
                var imageContainer = utilities$$1.createElement(itemContainer, 'div', null, 'bl-list-image-container');

                var listItemImage = document.createElement('img');
                listItemImage.className = 'bl-lp-list-item-image';
                listItemImage.setAttribute('src', jsonObject.image);
                imageContainer.appendChild(listItemImage);
            }

            // ---------- Create language 1 container ----------//
            var language1Container = document.createElement('div');
            language1Container.className = 'bl-lp-list-item-language-container';
            textContainer.appendChild(language1Container);

            // Create lang1 sound button container.
            var lang1SoundButtonContainer = document.createElement('div');
            lang1SoundButtonContainer.className = 'bl-lp-list-item-sound-container';
            language1Container.appendChild(lang1SoundButtonContainer);

            // Check if lang 1 has sound, if so add button to the container.
            if (jsonObject.lang1_sound.length > 0) {
                var soundButton = utilities$$1.createElement(lang1SoundButtonContainer, 'button', null, 'bl-lp-list-item-sound-button', null, globals.pgPrivateAssets.getImage('bilingualButtonSound').getUrl());
                soundButton.setAttribute('data-sound', jsonObject.lang1_sound);
                soundButton.addEventListener('click', function (event) {
                    return _this4._listItemSoundButtonClickHandler(event);
                });
            }

            // Create lang1 text.
            var lang1TextContainer = document.createElement('p');
            lang1TextContainer.className = 'bl-li-list-item-text';
            lang1TextContainer.appendChild(document.createTextNode(jsonObject.lang1_text));
            language1Container.appendChild(lang1TextContainer);

            // ---------- Create language 2 container ----------//
            var language2Container = document.createElement('div');
            language2Container.className = 'bl-lp-list-item-language-container';
            textContainer.appendChild(language2Container);

            // Create lang2 sound button container.
            var lang2SoundButtonContainer = document.createElement('div');
            lang2SoundButtonContainer.className = 'bl-lp-list-item-sound-container';
            language2Container.appendChild(lang2SoundButtonContainer);

            // Check if lang 2 has sound, if so add button to the container.
            if (jsonObject.lang2_sound.length > 0) {
                var _soundButton = utilities$$1.createElement(lang2SoundButtonContainer, 'button', null, 'bl-lp-list-item-sound-button', null, globals.pgPrivateAssets.getImage('bilingualButtonSound').getUrl());
                _soundButton.setAttribute('data-sound', jsonObject.lang2_sound);
                _soundButton.addEventListener('click', function (event) {
                    return _this4._listItemSoundButtonClickHandler(event);
                });
            }

            // Create lang2 text.
            var lang2TextContainer = document.createElement('p');
            lang2TextContainer.className = 'bl-li-list-item-text';
            lang2TextContainer.appendChild(document.createTextNode(jsonObject.lang2_text));
            language2Container.appendChild(lang2TextContainer);

            // Check if lang 2 has sound, if so add button to the container.
            if (jsonObject.lang2_sound.length === 0 && jsonObject.lang1_sound.length === 0) {
                /* ItemContainer.tabIndex = 0; */
            }
        }
    }, {
        key: '_listItemSoundButtonClickHandler',
        value: function _listItemSoundButtonClickHandler(event) {
            this._sound = new howler_2({
                src: [event.target.getAttribute('data-sound')]
            });
            this._sound.play();
        }
    }, {
        key: '_resetTextInputs',
        value: function _resetTextInputs() {
            if (this._canSearch === false) {
                return;
            }

            document.getElementById('bl-lp-input1').value = '';
            document.getElementById('bl-lp-input2').value = '';

            this._jsonSearchList = [];

            var searchListContainer = document.getElementById('bl-lp-search-list-container');
            var predefinedListContainer = document.getElementById('bl-lp-predefined-list-container');
            predefinedListContainer.style.display = 'block';
            searchListContainer.style.display = 'none';
            searchListContainer.innerHTML = '';
        }
    }]);
    return Bilingual$$1;
}();

var Navigation$$1 = function () {
    function Navigation$$1() {
        var _this = this;

        var parentElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        classCallCheck(this, Navigation$$1);

        this._pageLinks = null;
        this._internalPageLinks = [];
        this._burgerLinks = [];

        var salabyNavigation = document.createElement('div');
        salabyNavigation.id = 'salaby-navigation';

        if (parentElement) {
            parentElement.appendChild(salabyNavigation);
        } else {
            document.body.appendChild(salabyNavigation);
        }

        // ---------- salaby logo ----------//
        var logoUrl = globals.pgPrivate.getParameter('url_salaby').asString();
        if (liquidData.BreadCrumbs.length > 0) {
            logoUrl = liquidData.SiteUri;
        }
        var logoButton = utilities$$1._createElement(salabyNavigation, 'a', 'button-logo', null, globals.pgPrivate.getText('text_link_salaby').asString());

        logoButton.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('salabyNavigationLogo').getUrl() + '\')';
        logoButton.href = logoUrl;

        // ---------- Notification button ----------//

        if (liquidData.UserData.IsAuthenticated === true) {
            var buttonStudioNotification = utilities$$1._createElement(salabyNavigation, 'button', 'button-studio-notification', null, globals.pgPrivate.getText('text_button_hamburger').asString());
            buttonStudioNotification.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('salabyStudioNotification').getUrl() + '\')';
            buttonStudioNotification.addEventListener('click', function (event) {
                event.currentTarget.blur();

                // Remove side panel if one exists.
                if (document.getElementById('side-panel-wrapper')) {
                    document.getElementById('side-panel-wrapper').parentElement.removeChild(document.getElementById('side-panel-wrapper'));
                }

                utilities$$1.deactivatePageLinks();

                utilities$$1.createSidePanel();
                var sidePanelHeader = document.getElementById('side-panel-header');
                utilities$$1.createElement(sidePanelHeader, 'h2', null, null, globals.pgPrivate.getText('text_notification_header').asString());

                var sidePanelContainer = document.getElementById('side-panel-container');
                var sidePanelNotificationsContainer = utilities$$1.createElement(sidePanelContainer, 'ul');
                sidePanelNotificationsContainer.style.height = 'calc(100% - 40px)';

                var cachebuster = Math.round(new Date().getTime() / 1000);
                var bilingualJSONURL = globals.pgPrivate.getParameter('url_notification_api').asString() + '?cb=' + cachebuster;
                var xhr = new XMLHttpRequest();
                xhr.open('GET', bilingualJSONURL);
                xhr.withCredentials = true;
                xhr.onload = function () {
                    // ---------- Check if new notifications exists ----------//
                    var data = JSON.parse(xhr.responseText);
                    console.dir(data);

                    // 0 = ny
                    // 1 = oppdatering av oppgaven
                    // 2 = påminnelse

                    if (xhr.status === 200) {
                        if (data.newCount > 0) {
                            utilities$$1._createElement(document.getElementById('button-studio-notification'), 'span', null, null, data.newCount);
                        }

                        if (data.notifications.length > 0) {
                            var _loop = function _loop(i) {
                                if (i > 5) {
                                    return 'break';
                                }

                                var notificationJSONObject = data.notifications[i];
                                var notificationListElement = utilities$$1._createElement(sidePanelNotificationsContainer, 'li');
                                var viwedClassName = notificationJSONObject.viewed === true ? ' notification-viewed' : '';
                                var notificationLink = utilities$$1._createElement(notificationListElement, 'a', null, viwedClassName);
                                notificationLink.addEventListener('click', function () {
                                    var xhr = new XMLHttpRequest();
                                    xhr.open('POST', globals.pgPrivate.getParameter('url_notification_api').asString() + '/' + notificationJSONObject.entityId + '/viewed', true);
                                    xhr.withCredentials = true;
                                    xhr.onreadystatechange = function () {
                                        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                                            window.location.href = globals.pgPrivate.getParameter('url_teacher_studio').asString() + '/elev/#/?assignmentId=' + notificationJSONObject.entityId;
                                        }
                                    };
                                    xhr.send();
                                });

                                /* Console.log(globals.pgPrivate.getParameter('url_teacher_studio').asString() + '/elev/#/?assignmentId=' + notificationJSONObject.entityId);
                                console.log(notificationJSONObject.entityId); */

                                // notificationLink.href =

                                if (notificationJSONObject.type === 0) {
                                    utilities$$1._createElement(notificationLink, 'span', null, null, globals.pgPrivate.getText('text_notification_link_0').asString() + ' ');
                                    if (viwedClassName.length > 0) {
                                        utilities$$1._createElement(notificationLink, 'span', null, null, notificationJSONObject.title);
                                    } else {
                                        utilities$$1._createElement(notificationLink, 'span', null, null, '<strong>' + notificationJSONObject.title + '</strong>');
                                    }
                                } else {
                                    var pgDays = globals.pgPrivate.getGroup('days');
                                    var pgMonths = globals.pgPrivate.getGroup('months');
                                    var date = new Date(notificationJSONObject.assignmentDeadline);
                                    var dateString = pgDays.getText(date.getDay().toString()).asString() + ' ' + date.getDate() + '. ' + pgMonths.getText(date.getMonth().toString()).asString();

                                    utilities$$1._createElement(notificationLink, 'span', null, null, globals.pgPrivate.getText('text_notification_link_1').asString() + ' ');
                                    utilities$$1._createElement(notificationLink, 'span', null, null, notificationJSONObject.title + ' ');
                                    utilities$$1._createElement(notificationLink, 'span', null, null, globals.pgPrivate.getText('text_notification_link_1_deadline').asString() + ' ');
                                    if (viwedClassName.length > 0) {
                                        utilities$$1._createElement(notificationLink, 'span', null, null, dateString);
                                    } else {
                                        utilities$$1._createElement(notificationLink, 'span', null, null, '<strong>' + dateString + '</strong>');
                                    }
                                }
                            };

                            for (var i = 0; i < data.notifications.length; i++) {
                                var _ret = _loop(i);

                                if (_ret === 'break') break;
                            }

                            if (data.notifications.length > 6) {
                                var notificationButtonContainer = utilities$$1.createElement(sidePanelNotificationsContainer, 'li');
                                var notificationsLink = utilities$$1.createElement(notificationButtonContainer, 'a', 'side-panel-my-notifications-button', null, globals.pgPrivate.getText('text_link_user_notifications').asString());
                                notificationsLink.href = globals.pgPrivate.getParameter('url_user_notifications').asString();
                            }
                        } else {
                            // TODO: create no not message.
                            var noNotificationContainer = utilities$$1.createElement(sidePanelNotificationsContainer, 'li');
                            utilities$$1.createElement(noNotificationContainer, 'p', null, null, globals.pgPrivate.getText('text_notification_no_messages').asString());
                        }
                    }
                };
                var myPageLink = utilities$$1.createElement(sidePanelContainer, 'a', 'side-panel-my-page-button', null, globals.pgPrivate.getText('text_link_user_page').asString());
                myPageLink.href = globals.pgPrivate.getParameter('url_user_page').asString();
                xhr.send();
            });

            var cachebuster = Math.round(new Date().getTime() / 1000);
            var bilingualJSONURL = globals.pgPrivate.getParameter('url_notification_api').asString() + '?cb=' + cachebuster;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', bilingualJSONURL);
            xhr.withCredentials = true;
            xhr.onload = function () {
                var data = JSON.parse(xhr.responseText);
                if (data.newCount > 0) {
                    utilities$$1._createElement(document.getElementById('button-studio-notification'), 'span', null, null, data.newCount);
                }
            };
            xhr.send();
        }

        // ---------- Burger button ----------//
        var burgerButton = utilities$$1._createElement(salabyNavigation, 'button', 'button-submenu', null, globals.pgPrivate.getText('text_button_hamburger').asString());
        burgerButton.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('salabyBurger').getUrl() + '\')';
        burgerButton.addEventListener('click', function (event) {
            var salabyBurgerNavigationContainer = document.getElementById('salaby-burger-navigation-container');

            var burgerPanel = document.getElementById('salaby-burger-navigation-container');
            var isOpen = event.currentTarget.getAttribute('data-open');
            if (isOpen === '' || isOpen === null || isOpen === 'false') {
                event.currentTarget.setAttribute('data-open', 'true');

                TweenMax.set(burgerPanel, { height: 'auto' });
                TweenMax.from(burgerPanel, 0.2, { height: 0 });

                Array.from(salabyBurgerNavigationContainer.getElementsByTagName('a')).concat(Array.from(salabyBurgerNavigationContainer.getElementsByTagName('button'))).forEach(function (element) {
                    element.tabIndex = 0;
                });
            } else {
                event.currentTarget.setAttribute('data-open', 'false');
                TweenMax.to(burgerPanel, 0.2, { height: 0 });

                Array.from(salabyBurgerNavigationContainer.getElementsByTagName('a')).concat(Array.from(salabyBurgerNavigationContainer.getElementsByTagName('button'))).forEach(function (element) {
                    element.tabIndex = -1;
                });
            }
        });

        // ---------- Create burger navigation container ----------//
        var salabyBurgerNavigationContainer = document.createElement('div');
        salabyBurgerNavigationContainer.id = 'salaby-burger-navigation-container';

        if (parentElement) {
            parentElement.appendChild(salabyBurgerNavigationContainer);
        } else {
            document.body.appendChild(salabyBurgerNavigationContainer);
        }
        TweenMax.set(salabyBurgerNavigationContainer, { height: 0 });

        // ---------- Create Breadcrumbs ----------//
        if (liquidData.BreadCrumbs.length > 0) {
            var salabyBreadcrumbs = utilities$$1._createElement(salabyBurgerNavigationContainer, 'ul', 'salaby-breadcrumbs');
            utilities$$1._createElement(salabyBreadcrumbs, 'div', 'breadcrumbs-cover');

            var firstBreadcrumb = true;
            liquidData.BreadCrumbs.forEach(function (breadcrumb) {
                var listElement = utilities$$1._createElement(salabyBreadcrumbs, 'li');
                var link = utilities$$1._createElement(listElement, 'a');
                link.href = liquidData.SiteUri + breadcrumb.Href;
                link.tabIndex = -1;
                _this._burgerLinks.push(link);

                if (firstBreadcrumb === true) {
                    firstBreadcrumb = false;
                    link.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('bredcrumbsHome').getUrl() + '\')';
                    /* Utilities.addBackgroundCssImage(link, globals.pgPrivateAssets, ''); */
                } else {
                    link.appendChild(document.createTextNode(breadcrumb.Title));
                }
                listElement.appendChild(link);
            });

            var lastListElement = utilities$$1._createElement(salabyBreadcrumbs, 'li');
            var lastListText = utilities$$1._createElement(lastListElement, 'span');
            lastListText.appendChild(document.createTextNode(liquidData.CurrentBreadCrumb.Title));
        }

        var salabyButtonsContainer = utilities$$1._createElement(salabyBurgerNavigationContainer, 'ul', 'salaby-buttons-container');

        // ---------- Change laguage button ----------//
        var switchLanguage = null;
        var switchLanguageString = void 0;
        if (liquidData.Language.CultureCode === 'nb-no') {
            switchLanguage = this._findLanguageByCultureCode('nn-no');
            switchLanguageString = globals.pgPrivate.getText('text_button_change_to_nn').asString();
        } else {
            switchLanguage = this._findLanguageByCultureCode('nb-no');
            switchLanguageString = globals.pgPrivate.getText('text_button_change_to_bm').asString();
        }

        if (switchLanguage !== null) {
            var salabyLanguageButtonsContainer = utilities$$1._createElement(salabyButtonsContainer, 'li');
            var salabyChangeLanguageButton = utilities$$1._createElement(salabyLanguageButtonsContainer, 'a', null, null, switchLanguageString);
            salabyChangeLanguageButton.href = switchLanguage.SetLanguageUrl;
            salabyChangeLanguageButton.tabIndex = -1;
        }

        // ---------- Create bilingual language button ----------//
        this._bilingualComponent = null;
        this._bilingualComponent = new Bilingual$$1();

        var buttonContainer = utilities$$1._createElement(salabyButtonsContainer, 'li');
        salabyButtonsContainer.appendChild(buttonContainer);

        if (liquidData.BilingualLanguage === null) {
            // TODO: add podium text.
            var openSelectBilingualLanguageButton = utilities$$1._createElement(buttonContainer, 'button', 'bilingual-select-language-text-button', null, globals.pgPrivate.getText('text_bilingual_select_header').asString());
            openSelectBilingualLanguageButton.tabIndex = -1;
            openSelectBilingualLanguageButton.addEventListener('click', function () {
                utilities$$1.deactivatePageLinks();
                openSelectBilingualLanguageButton.blur();
                _this._bilingualComponent.selectLanguageButtonClick();
            });
        } else {
            var bilingualButton = document.createElement('div');
            bilingualButton.id = 'bilingual-button';
            buttonContainer.appendChild(bilingualButton);

            // TODO: add podium text.
            var _openSelectBilingualLanguageButton = utilities$$1._createElement(bilingualButton, 'button', 'bilingual-select-language-button', null, liquidData.BilingualLanguage.EnglishName);
            _openSelectBilingualLanguageButton.tabIndex = -1;
            var span = document.createElement('span');
            span.appendChild(document.createTextNode(globals.pgPrivate.getText('text_bilingual_header').asString() + ' '));
            _openSelectBilingualLanguageButton.insertBefore(span, _openSelectBilingualLanguageButton.childNodes[0]);
            _openSelectBilingualLanguageButton.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('bilingualButtonArrow').getUrl() + '\')';
            _openSelectBilingualLanguageButton.addEventListener('click', function () {
                utilities$$1.deactivatePageLinks();
                _openSelectBilingualLanguageButton.blur();
                _this._bilingualComponent.selectLanguageButtonClick();
            });

            var bilingualToggleComponetButton = utilities$$1._createElement(bilingualButton, 'button', 'bilingual-toggle-componet-button');
            bilingualToggleComponetButton.tabIndex = -1;
            bilingualToggleComponetButton.style.backgroundImage = 'url(\'' + globals.pgPrivateAssets.getImage('bilingualButtonToggleEye').getUrl() + '\')';
            bilingualToggleComponetButton.addEventListener('click', function () {
                utilities$$1.deactivatePageLinks();
                bilingualToggleComponetButton.blur();
                _this._bilingualComponent.openLanguagePanel();
            });
        }
    }

    createClass(Navigation$$1, [{
        key: '_salabyBurgerClickHandler',
        value: function _salabyBurgerClickHandler() {
            if (this._salabyBurgerOpen === false) {
                this._pageLinks.forEach(function (element) {
                    element.tabIndex = -1;
                });

                this._burgerLinks.forEach(function (element) {
                    element.tabIndex = 0;
                });

                TweenMax.to(document.getElementById('salaby-burger-navigation-container'), 0.4, { height: document.getElementById('salaby-burger-navigation-container').scrollHeight, onComplete: function onComplete() {
                        TweenMax.set(document.getElementById('salaby-burger-navigation-container'), { clearProps: 'all' });
                    }
                });

                utilities$$1.addBackgroundCssImage(document.getElementById('salaby-burger'), globals.pgPrivateAssets, 'menuCloseButton');
                this._salabyBurgerOpen = true;
            } else {
                this._burgerLinks.forEach(function (element) {
                    element.tabIndex = -1;
                });

                this._pageLinks.forEach(function (element) {
                    element.tabIndex = 0;
                });

                TweenMax.to(document.getElementById('salaby-burger-navigation-container'), 0.4, { height: 0 });

                utilities$$1.addBackgroundCssImage(document.getElementById('salaby-burger'), globals.pgPrivateAssets, 'salabyBurger');
                this._salabyBurgerOpen = false;
            }
        }
    }, {
        key: 'addPageLinks',
        value: function addPageLinks(pageLinks) {
            this._pageLinks = [].concat(toConsumableArray(this._internalPageLinks), toConsumableArray(pageLinks));
        }

        // ---------- Functions for bilingual button ----------//

    }, {
        key: '_bilingualSelectLanguageButtonClick',
        value: function _bilingualSelectLanguageButtonClick() {
            this._bilingualComponent.selectLanguageButtonClick();
        }
    }, {
        key: '_openBilingualPanelClickHandler',
        value: function _openBilingualPanelClickHandler() {
            this._bilingualComponent.openLanguagePanel();
        }
    }, {
        key: '_findLanguageByCultureCode',
        value: function _findLanguageByCultureCode(cultureCode) {
            var language = null;
            liquidData.Languages.forEach(function (element) {
                if (element.CultureCode === cultureCode) {
                    language = element;
                }
            });
            return language;
        }
    }]);
    return Navigation$$1;
}();

var Header$$1 = function () {
    function Header$$1() {
        var _this = this;

        var parentElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        classCallCheck(this, Header$$1);


        this.fontPG = null;

        var headerPG = globals.pg.getGroupOptional('header', null);
        if (headerPG !== null) {

            var header = null;
            if (parentElement) {
                header = utilities$$1.createElement(parentElement, 'div', 'header');
            } else {
                header = utilities$$1.createElement(document.body, 'div', 'header');
            }

            header.style.height = headerPG.getGroup('settings').getParameter('headerHeight').asString() + 'px';
            utilities$$1.addBackgroundCssImage(header, headerPG, 'backgroundImage');

            var headerTitle = null;

            var headerContentPG = headerPG.getTextOptional('content', null);
            if (headerContentPG === null) {
                headerTitle = document.createElement('h1');
                headerTitle.id = 'header-title';

                if (headerPG.getGroup('settings').getParameter('textOutline').asBool() === true) {
                    headerTitle.className = 'header-title-stroke';
                }

                headerTitle.appendChild(document.createTextNode(liquidData.Title.toUpperCase()));
                header.appendChild(headerTitle);
            } else {
                var contentString = headerContentPG.asString();

                if (headerContentPG.hasImage()) {
                    // HeaderContentPG.getImage().;
                    headerContentPG.getImage().h.load(function (podiumImage) {
                        var img = podiumImage.h.getImage();
                        img.setAttribute('data-align', headerPG.getGroup('settings').getParameter('imageAlign').asString());
                        img.setAttribute('data-image-width', img.width);
                        img.setAttribute('data-image-height', img.height);
                        img.id = 'header-image';

                        document.getElementById('header').appendChild(img);
                        _this._windowResizeHandler();
                    });

                    // Utilities.createImageElement()
                } else if (contentString.length > 0) {
                    headerTitle = document.createElement('h1');
                    headerTitle.id = 'header-title';
                    headerTitle.appendChild(document.createTextNode(contentString));
                    header.appendChild(headerTitle);
                    this._windowResizeHandler();
                }
            }

            // ---------- Check if header exist ----------//
            if (headerTitle !== null) {
                this.fontPG = headerPG.getGroup('settings').getGroupOptional('font', null);
                if (this.fontPG !== null) {
                    var family = this.fontPG.getParameter('family').asString().split(' ').join('+');
                    var weight = this.fontPG.getParameter('weight').asString();
                    var fontString = family + ':' + weight;

                    var linkNode = document.createElement('link');
                    linkNode.setAttribute('href', 'https://fonts.googleapis.com/css?family=' + fontString);
                    linkNode.setAttribute('rel', 'stylesheet');
                    document.head.appendChild(linkNode);

                    headerTitle.style.fontFamily = this.fontPG.getParameter('family').asString();
                    headerTitle.style.fontWeight = weight;
                    headerTitle.style.color = this.fontPG.getParameter('color').asString();
                    headerTitle.style.fontSize = this.fontPG.getParameter('size').asString();
                    this._windowResizeHandler();
                }
            }

            var pgButton = headerPG.getGroupOptional('button', null);
            if (pgButton !== null) {
                var color = headerPG.getGroup('settings').getParameter('buttonBackgroundColor').asString();
                var url = pgButton.getParameter('url').asString();
                var align = headerPG.getGroup('settings').getParameter('buttonAlign').asString();
                var text = pgButton.getText('text').asString();
                var buttonArrowURI = pgButton.getImage('button-arrow').getUrl();

                var button = utilities$$1.createTextButton(header, text, 'header-button', null, null, -1, 'a', url);
                utilities$$1.addBackgroundCssImage(button, null, null, buttonArrowURI);
                button.style.border = headerPG.getGroup('settings').getParameter('buttonBorder').asString();
                button.style.color = headerPG.getGroup('settings').getParameter('buttonFontColor').asString();

                if (align === 'bottom') {
                    button.style.marginTop = '200px';
                }

                if (document.getElementById('header-title') !== null) {
                    button.style.marginTop = '5px';
                }

                button.style.backgroundColor = color;
            }

            var backButtonPI = headerPG.getImageOptional('backButton', null);
            if (backButtonPI !== null) {
                utilities$$1.createImageButton(header, headerPG, 'backButton', 'header-back-button', null, function () {
                    window.history.back();
                });
            }

            // ---------- Add events ----------//
            this._windowResizeHandler();
            this._windowResizeEventHandler = function (event) {
                return _this._windowResizeHandler(event);
            };
            window.addEventListener('resize', this._windowResizeEventHandler);
        }
    }

    // ---------- Event Handler ----------//


    createClass(Header$$1, [{
        key: '_windowResizeHandler',
        value: function _windowResizeHandler() {
            // ---------- Resize header title ----------//
            var headerTitle = document.getElementById('header-title');
            if (headerTitle !== null && this.fontPG !== null) {
                headerTitle.style.fontSize = this.fontPG.getParameter('size').asString();

                if (headerTitle.clientHeight > 180) {
                    // Let startFontSize = parseInt($('#default-header-title').css('font-size'));
                    var startFontSize = 80;

                    while (headerTitle.clientHeight > 180) {
                        startFontSize -= 1;

                        headerTitle.style.fontSize = startFontSize + 'px';
                    }
                }
            }

            // ---------- Resize header image ----------//
            var headerImage = document.getElementById('header-image');
            var header = document.getElementById('header');
            if (headerImage !== null) {
                var imgWidth = Number(headerImage.getAttribute('data-image-width'));
                var imgHeight = Number(headerImage.getAttribute('data-image-height'));

                var widthRatio = header.clientWidth / imgWidth;
                var heightRatio = header.clientHeight / imgHeight;

                var fitRatio = Math.min(widthRatio, heightRatio);
                if (fitRatio > 1) {
                    fitRatio = 1;
                }

                var imageWidth = imgWidth * fitRatio;
                var imageHeight = imgHeight * fitRatio;
                headerImage.style.width = imageWidth + 'px';
                headerImage.style.height = imageHeight + 'px';

                var left = header.clientWidth / 2 - imageWidth / 2;
                var top = header.clientHeight / 2 - imageHeight / 2;
                headerImage.style.left = left + 'px';

                if (headerImage.getAttribute('data-align') === 'center') {
                    headerImage.style.top = top + 'px';
                } else if (headerImage.getAttribute('data-align') === 'top') {
                    headerImage.style.top = '0px';
                } else {
                    headerImage.style.top = '';
                    headerImage.style.bottom = '0px';
                }
            }
        }
    }]);
    return Header$$1;
}();

var Carousel = function () {
    function Carousel(pg) {
        var _this = this;

        classCallCheck(this, Carousel);

        this._pg = pg;

        this._pgCarousel = this._pg.getGroupOptional('carousel', null);

        // ---------- Carousel do not exists, return. ----------//
        if (this._pgCarousel === null) {
            return;
        }

        this.assetsGroupPodium = this._pgCarousel.getGroup('assets');

        this._pgItems = null;
        this.currentCarouselItemIndex = 0;
        this.carouselItemsLength = 0;

        // ---------- Create dom structure ----------//
        var carouselBackgroundWrapper = utilities$$1.createElement(document.body, 'div', 'carousel-background-wrapper');
        var carouselWrapper = utilities$$1.createElement(carouselBackgroundWrapper, 'div', 'carousel-wrapper');
        var carousel = utilities$$1.createElement(carouselWrapper, 'div', 'carousel');
        var carouselButtonLeftContainer = utilities$$1.createElement(carousel, 'div', 'carousel-button-left-container');
        var carouselButtonRightContainer = utilities$$1.createElement(carousel, 'div', 'carousel-button-right-container');
        var carouselItemsWrapper = utilities$$1.createElement(carousel, 'div', 'carousel-items-wrapper');
        var carouselItemsContainer = utilities$$1.createElement(carouselItemsWrapper, 'div', 'carousel-items-container');

        var carouselItemIndicatorWrapper = utilities$$1.createElement(carousel, 'div', 'carousel-item-indicator-wrapper');
        var carouselItemIndicatorContainer = utilities$$1.createElement(carouselItemIndicatorWrapper, 'div', 'carousel-item-indicator-container');

        var backgroundimagePG = this.assetsGroupPodium.getImageOptional('backgroundImage', null);
        if (backgroundimagePG !== null) {
            utilities$$1.addBackgroundCssImage(document.getElementById('carousel-background-wrapper'), null, null, backgroundimagePG.getUrl());
            document.getElementById('carousel-background-wrapper').style.paddingTop = this.assetsGroupPodium.getParameter('backgroundImageHeight').asString();
            document.getElementById('carousel-wrapper').style.backgroundColor = this.assetsGroupPodium.getParameter('backgroundColor').asString();
        }

        this._windowResizeHandler();
        this._windowResizeEventHandler = function (event) {
            return _this._windowResizeHandler(event);
        };
        window.addEventListener('resize', this._windowResizeEventHandler);

        TweenMax.to(document.getElementById('carousel'), 0.3, { css: { opacity: 1 } });

        var leftArrowClickHandler = function leftArrowClickHandler() {
            if (_this.currentCarouselItemIndex >= 0) {
                _this.currentCarouselItemIndex = 0;
                return;
            }

            var carouselMarginLeft = _this.carouselItemWidth * _this.currentCarouselItemIndex + _this.carouselItemWidth;
            _this.currentCarouselItemIndex += 1;

            TweenMax.to(document.getElementById('carousel-items-container'), 0.3, { css: { 'margin-left': carouselMarginLeft } });

            _this._setCarouselButtonsOpacity();
        };
        utilities$$1.createImageButton(carouselButtonLeftContainer, this.assetsGroupPodium, 'leftButton', null, 'carousel-button-left-arrow', leftArrowClickHandler, -1, 'button');

        var rightArrowClickHandler = function rightArrowClickHandler() {
            if (_this.currentCarouselItemIndex <= -(_this.carouselItemsLength - 1)) {
                _this.currentCarouselItemIndex = -(_this.carouselItemsLength - 1);
                return;
            }

            var carouselMarginLeft = _this.carouselItemWidth * _this.currentCarouselItemIndex - _this.carouselItemWidth;
            _this.currentCarouselItemIndex -= 1;

            TweenMax.to(document.getElementById('carousel-items-container'), 0.3, { css: { 'margin-left': carouselMarginLeft } });

            _this._setCarouselButtonsOpacity();
        };
        utilities$$1.createImageButton(carouselButtonRightContainer, this.assetsGroupPodium, 'rightButton', null, 'carousel-button-right-arrow', rightArrowClickHandler, -1, 'button');

        // ---------- Load Item images ----------//
        // TODO: Address Finner'n by handling array loading,
        // Maby convert array to podium group?
        this._pgItems = this._pgCarousel.getGroups('item');
        this.carouselItemsLength = this._pgItems.length;
        var imagesToLoad = 0;
        var imagesLoaded = 0;
        this._pgItems.forEach(function (item) {
            if (item.getText('content').hasImage() === true) {
                imagesToLoad += 1;
            }
        });

        this._setCarouselButtonsOpacity();

        // Preload the images.
        this._pgItems.forEach(function (item) {
            if (item.getText('content').hasImage() === true) {
                item.getText('content').getImage().h.load(function () {
                    imagesLoaded += 1;

                    if (imagesToLoad === imagesLoaded) {
                        _this._pgItems.forEach(function (item) {
                            var carouselItemWrapper = utilities$$1.createElement(carouselItemsContainer, 'div', null, 'carousel-item-wrapper');
                            var carouselItemContainer = utilities$$1.createElement(carouselItemWrapper, 'div', null, 'carousel-item-container');
                            var carouselItemImageContainer = utilities$$1.createElement(carouselItemContainer, 'div', null, 'carousel-item-image-container');
                            var carouselItemTextContainer = utilities$$1.createElement(carouselItemContainer, 'div', null, 'carousel-item-text-container');

                            var carouselItemImage = item.getText('content').getImage().h.getImage();
                            carouselItemImage.className = 'carousel-item-image';
                            carouselItemImageContainer.appendChild(carouselItemImage);

                            var carouselItemHeader = utilities$$1.createElement(carouselItemTextContainer, 'div', null, 'carousel-item-header');
                            carouselItemHeader.innerHTML = item.getText('header').asString();

                            var carouselItemText = utilities$$1.createElement(carouselItemTextContainer, 'div', null, 'carousel-item-text');
                            carouselItemText.innerHTML = item.getText('content').asString();

                            utilities$$1.createTextButton(carouselItemTextContainer, item.getText('buttonText').asString(), null, 'carousel-item-button', null, -1, 'a', item.getParameter('url').asString());

                            carouselItemWrapper.style.width = carouselItemsWrapper.clientWidth + 'px';

                            utilities$$1.createElement(carouselItemIndicatorContainer, 'div', null, 'carousel-item-indicator');
                        });
                        _this._windowResizeHandler();
                        _this._setCarouselButtonsOpacity();
                    }
                });
            }
        });
    }

    createClass(Carousel, [{
        key: '_setCarouselButtonsOpacity',
        value: function _setCarouselButtonsOpacity() {
            var _this2 = this;

            if (this.currentCarouselItemIndex <= -(this.carouselItemsLength - 1)) {
                document.getElementById('carousel-button-right-container').style.opacity = '0';
            } else {
                document.getElementById('carousel-button-right-container').style.opacity = '1';
            }

            if (this.currentCarouselItemIndex >= 0) {
                document.getElementById('carousel-button-left-container').style.opacity = '0';
            } else {
                document.getElementById('carousel-button-left-container').style.opacity = '1';
            }

            var carouselItemsIndicator = Array.from(document.getElementsByClassName('carousel-item-indicator'));
            var index = 0;
            carouselItemsIndicator.forEach(function (element) {
                if (index === Math.abs(_this2.currentCarouselItemIndex)) {
                    utilities$$1._addClassName(element, 'carousel-item-indicator-selected');
                } else {
                    utilities$$1._removeClassName(element, 'carousel-item-indicator-selected');
                }
                index += 1;
            });
        }
    }, {
        key: '_windowResizeHandler',
        value: function _windowResizeHandler() {
            var _this3 = this;

            if (this._pgItems !== null) {
                this.carouselItemWidth = document.getElementById('carousel-items-wrapper').clientWidth;
                document.getElementById('carousel-items-container').style.width = this.carouselItemWidth * this._pgItems.length + 'px';

                var caruselItems = document.getElementsByClassName('carousel-item-wrapper');
                Array.from(caruselItems).forEach(function (item) {
                    item.style.width = _this3.carouselItemWidth + 'px';
                });

                var carouselMarginLeft = this.carouselItemWidth * this.currentCarouselItemIndex;
                document.getElementById('carousel-items-container').style.marginLeft = carouselMarginLeft + 'px';

                var indicatorMarginLeft = document.getElementById('carousel-item-indicator-wrapper').clientWidth / 2 - document.getElementById('carousel-item-indicator-container').clientWidth / 2;
                document.getElementById('carousel-item-indicator-container').style.marginLeft = indicatorMarginLeft + 'px';
            }
        }
    }]);
    return Carousel;
}();

var Footer$$1 = function Footer$$1(parentElement) {
    classCallCheck(this, Footer$$1);

    // ---------- Podium variables ----------//
    this._pgAssets = globals.pg.getGroup('private').getGroup('assets');
    var footer = document.createElement('div');
    footer.id = 'footer';

    if (parentElement) {
        parentElement.appendChild(footer);
    } else {
        document.body.appendChild(footer);
    }

    // ---------- Add social media links ----------//
    var sosialMediaContainer = document.createElement('div');
    sosialMediaContainer.id = 'sosial-media-container';
    footer.appendChild(sosialMediaContainer);

    // ---------- Set sosial medi url's, if the site is unde salaby, or barnehagen. ----------//
    var sosialMediaUrlsPG = globals.pg.getGroup('private').getGroup('sosialMediaUrls');
    var footerFacebookUrl = '#';
    var footerInstagramUrl = '#';
    var footerYoutubeUrl = '#';

    if (liquidData.SiteUri.indexOf('barnehage.salaby.no') !== -1) {
        footerFacebookUrl = sosialMediaUrlsPG.getParameter('footerFacebookUrl2').asString();
        footerInstagramUrl = sosialMediaUrlsPG.getParameter('footerInstagramUrl2').asString();
        footerYoutubeUrl = sosialMediaUrlsPG.getParameter('footerYoutubeUrl2').asString();
    } else {
        footerFacebookUrl = sosialMediaUrlsPG.getParameter('footerFacebookUrl1').asString();
        footerInstagramUrl = sosialMediaUrlsPG.getParameter('footerInstagramUrl1').asString();
        footerYoutubeUrl = sosialMediaUrlsPG.getParameter('footerYoutubeUrl1').asString();
    }

    var youtubeAncour = utilities$$1._createElement(sosialMediaContainer, 'a', null, null, this._pgAssets.getText('button_footer_youtube').asString());
    youtubeAncour.style.backgroundImage = 'url(\'' + this._pgAssets.getText('button_footer_youtube').getImage().getUrl() + '\')';
    youtubeAncour.href = footerYoutubeUrl;

    var facebookAncour = utilities$$1._createElement(sosialMediaContainer, 'a', null, null, this._pgAssets.getText('button_footer_facebook').asString());
    facebookAncour.style.backgroundImage = 'url(\'' + this._pgAssets.getText('button_footer_facebook').getImage().getUrl() + '\')';
    facebookAncour.href = footerFacebookUrl;

    var instagramAncour = utilities$$1._createElement(sosialMediaContainer, 'a', null, null, this._pgAssets.getText('button_footer_instagram').asString());
    instagramAncour.style.backgroundImage = 'url(\'' + this._pgAssets.getText('button_footer_instagram').getImage().getUrl() + '\')';
    instagramAncour.href = footerInstagramUrl;

    // ---------- Add main links ----------//
    var mainLinkContainer = document.createElement('div');
    mainLinkContainer.id = 'footer-main-link-container';
    footer.appendChild(mainLinkContainer);

    globals.pg.getGroup('private').getGroup('footerMainLinks').getGroups('link').forEach(function (pglink) {
        var anchour = utilities$$1._createElement(mainLinkContainer, 'a', null, null, pglink.getText('text').asString());
        anchour.href = pglink.getParameter('url').asString();
    });

    // ---------- Add secoundary links ----------//
    var secondaryLinkContainer = document.createElement('div');
    secondaryLinkContainer.id = 'footer-secondary-link-container';
    footer.appendChild(secondaryLinkContainer);

    var secondaryLinks = globals.pg.getGroup('private').getGroup('footerSecondaryLinks').getGroups('link');
    secondaryLinks.forEach(function (pglink) {
        var anchour = utilities$$1._createElement(secondaryLinkContainer, 'a', null, null, pglink.getText('text').asString());
        anchour.href = pglink.getParameter('url').asString();
    });

    // ---------- Create logo section ----------//
    var footerLogoContainer = document.createElement('div');
    footerLogoContainer.id = 'footer-logo-container';
    footer.appendChild(footerLogoContainer);

    var logoUrl = globals.pg.getGroup('private').getParameter('url_salaby').asString();
    if (liquidData.BreadCrumbs.length > 0) {
        logoUrl = liquidData.SiteUri;
    }

    var logo = utilities$$1._createElement(footerLogoContainer, 'a', 'footer-logo', null, globals.pg.getGroup('private').getText('text_link_salaby').asString());
    logo.style.backgroundImage = 'url(\'' + this._pgAssets.getImage('footerLogo').getUrl() + '\')';
    logo.href = logoUrl;

    var publisherLink = utilities$$1._createElement(footerLogoContainer, 'a', 'footer-publisher-link', null, globals.pg.getGroup('private').getText('text_link_publisher').asString());
    publisherLink.href = globals.pg.getGroup('private').getParameter('url_publisher').asString();
};

var globals = {
  pg: null,
  pgPrivate: null,
  pgPrivateAssets: null,
  pgBilingual: null
};

export { globals, utilities$$1 as Utilities, Bilingual$$1 as Bilingual, Navigation$$1 as Navigation, Header$$1 as Header, Carousel, Footer$$1 as Footer };
